/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';

const AIDocumentManagerAPI = async (
  facility: string = '',
  year: string = '',
  documentType: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  if (!year || !facility || !documentType) {
    return [];
  }

  try {
    const response = await axios.request({
      method: 'GET',
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.AIDocumentManager}/${facility}/${year}/${documentType}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    return response.data.data;
  } catch (err) {
    console.log('err:', err);
  }
};

export default AIDocumentManagerAPI;
